/**
 * `<quick-view>` custom element (feature list v1.2).
 *
 * A card button carries data-quick-view with the product URL; the element
 * fetches that product page, injects its `.product` markup into the dialog
 * and opens it. The injected
 * `<product-form>` and variant picker upgrade themselves — the buy logic is
 * the page's own, not a copy. This script also reveals the card buttons:
 * without JavaScript they don't exist and the card link does the job.
 */
class QuickView extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.content = this.querySelector('[data-quick-view-content]');
    if (!this.dialog || !this.content) return;

    document.querySelectorAll('[data-quick-view]').forEach((button) => {
      button.hidden = false;
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-view]');
      if (trigger) {
        event.preventDefault();
        this.open(trigger.dataset.quickView);
        return;
      }
      if (event.target.closest('[data-quick-view-close]')) this.dialog.close();
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    /* le card arrivate dopo (load more, recently viewed) */
    new MutationObserver(() => {
      document.querySelectorAll('[data-quick-view][hidden]').forEach((button) => {
        button.hidden = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  open(url) {
    /* pagina intera, non section rendering: l'id runtime della sezione
       template (`template--<id>__main`) non è conoscibile da qui, e da un
       documento completo basta prendere `.product` */
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const product = doc.querySelector('.product');
        if (!product) {
          window.location.href = url;
          return;
        }
        // La PDP porta con sé il breadcrumb: in una finestra sovrapposta è
        // rumore, anche per tastiera e screen reader.
        product.querySelector('.breadcrumb')?.remove();
        this.content.innerHTML = '';
        this.content.appendChild(product);
        this.dialog.showModal();
      })
      .catch(() => {
        window.location.href = url;
      });
  }
}

if (!customElements.get('quick-view')) {
  customElements.define('quick-view', QuickView);
}
